import { URL_ALIAS } from './../config_module';
import * as _ from 'lodash';
import { authorizeOAuth } from '../services/oauth/oAuthService';
import $ from 'jquery';
import { getRefreshTokenFromStorage, getTokenFromStorage, LOCAL_STORAGE } from '../shared';
import { LTI_ROLES } from '../const';
import { isEmbbededInTeams } from '../services/crossPlatform/crossPlatformService';

function addMoodleParameters(data) {
  const resourceId = localStorage.getItem(LOCAL_STORAGE.LIS_RESOURCE_ID);
  // Sin lis_resource_id no hay vínculo con la actividad Moodle: no enviar parámetros LTI
  // (p. ej. navegación fuera de la vista enjaulada o entre lessons en unidad custom).
  if (_.isNil(resourceId)) {
    return;
  }

  const outcomeServiceUrl = localStorage.getItem(LOCAL_STORAGE.LIS_OUTCOME_SERVICE_URL);
  const resultSourceId = localStorage.getItem(LOCAL_STORAGE.LIS_RESULT_SOURCED_ID);
  // Solo adjuntar callback de notas cuando el contexto LTI de Moodle está completo.
  // lis_resource_id va junto a outcome/sourcedid para que el BE pueda asociar la nota
  // al módulo correcto sin enviar grades a Moodle sin contexto válido.
  if (!_.isNil(outcomeServiceUrl) && !_.isNil(resultSourceId)) {
    const lis_outcome_service_url_parsed = new URL(outcomeServiceUrl);
    if (data.data.user_email) {
      lis_outcome_service_url_parsed.searchParams.set('studentEmail', data.data.user_email);
    }

    data.data = {
      ...data.data,
      lis_outcome_service_url: lis_outcome_service_url_parsed.toString(),
      lis_result_sourcedid: resultSourceId,
      lis_resource_id: resourceId
    };
  }
}

let submitData = (data, url, target = '_blank') => {
  let form = $('<form>', {
    target,
    action: decodeURIComponent(url),
    method: 'POST'
  });

  let button = document.createElement('input');
  button.setAttribute('type', 'submit');
  form.appendTo(button);

  $.each(data, function(key, val) {
    $('<input>')
      .attr({
        type: 'hidden',
        name: key,
        value: val
      })
      .appendTo(form);
  });
  form.appendTo('body').submit();
};

function getLTIData(launchUrl, openBookConfig) {
  const { url, query } = splitUrlAndQueryAsCustomParameters(launchUrl);

  const user = openBookConfig.account.user;
  const sectionId = openBookConfig.classroom.sectionId;
  const consumerKey = openBookConfig.institution.ltiConsumerKey;
  const consumerSecret = openBookConfig.institution.ltiConsumerPassword;
  const activityId = openBookConfig.questionActivityId;
  const accessToken = getTokenFromStorage();
  const refreshToken = getRefreshTokenFromStorage();
  const userRole = LTI_ROLES[openBookConfig.classroom.role];

  const data = {
    url: url,
    method: 'POST',
    consumerKey,
    consumerSecret,
    signatureMethod: 'HMAC-SHA1',
    data: {
      user_id: user._id,
      roles: userRole,
      context_id: sectionId,
      lis_person_name_given: user.name,
      lis_person_name_family: user.surname,
      user_image: user.picture.startsWith('http') ? user.picture : URL_ALIAS + user.picture,
      launch_presentation_locale: user.language,
      custom_accessToken: accessToken,
      custom_refreshToken: refreshToken,
      ...query
    }
  };

  if (user.email) {
    data.data.user_email = user.email;
  }

  if (window.location.href.length > 255) {
    console.log(`URL is too long: ${window.location.href}`);
  } else {
    data.data.custom_originUrl = window.location.href;
  }

  if (activityId) data.data.activityId = activityId;
  addMoodleParameters(data);
  return { url, data: authorizeOAuth(data) };
}

const splitUrlAndQueryAsCustomParameters = function(launchUrl) {
  const url = launchUrl.split('?')[0];
  const queryString = launchUrl.split('?')[1];
  const query = {};
  if (queryString) {
    queryString.split('&').forEach(function(part) {
      const item = part.split('=');
      query[`custom_${item[0]}`] = decodeURIComponent(item[1]);
    });
  }
  return { url, query };
};

export function sendLTI(openBookConfig) {
  let launchUrl = openBookConfig.book.url || openBookConfig.unit.url || openBookConfig.lesson.url;
  const { url, data } = getLTIData(launchUrl, openBookConfig);
  const target = isEmbbededInTeams() ? '_self' : '_blank';
  submitData(data, url, target);
}

export function sendLTIOffline(openBookConfig) {
  const launchUrl = openBookConfig.launchUrl;
  const { url, data } = getLTIData(launchUrl, openBookConfig);
  return $.ajax({
    type: 'POST',
    url: url,
    data: data
  });
}
